/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayLanePlayerDtoSchema = z.object({
  userId: z.string().nullish(),
  name: z.string().nullish(),
  champion: z.string().nullish(),
  win: z.optional(z.boolean()),
});
